import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'ecm-mat-jcvd',
    templateUrl: 'material-jcvd.html',
    standalone: true,
    imports: [],
})
export class MaterialJcvdComponent implements OnInit, OnDestroy {
    public isScriptLoaded = false;

    public ngOnInit() {
        const JCVD = (window as any).JCVD;
        if (!JCVD) {
            const tagJCVD = document.getElementById('script-jcvd');
            if (!tagJCVD) {
                const node = document.createElement('script');
                node.src = 'assets/jcvd.bundle.min.js';
                node.type = 'text/javascript';
                node.async = false;
                node.id = 'script-jcvd';
                node.addEventListener('load', this.isLoaded);
                document.getElementsByTagName('head')[0].appendChild(node);
            } else {
                tagJCVD.addEventListener('load', this.isLoaded);
            }
        } else {
            this.isScriptLoaded = true;
            JCVD.reconnect();
        }
    }

    public ngOnDestroy() {
        const JCVD = (window as any).JCVD;
        if (JCVD) {
            const tagJCVD = document.getElementById('script-jcvd');
            if (tagJCVD) {
                tagJCVD.removeEventListener('load', this.isLoaded);
            }
            // Disconnect MutationObserver
            JCVD.kickWithChuckNorris();
        }
    }

    private isLoaded = () => {
        this.isScriptLoaded = true;
    };
}
